import { getData } from "api/dataVisualisation/client";
import { GenerationForecastModel } from "models/generationForecast/generationForecastModel";

export const getGenerationForecast14DayData = async (): Promise<
  GenerationForecastModel[]
> => {
  const { data } = await getData("/forecast/availability/summary/14D");
  return data;
};

export const getGenerationForecast3YearData = async (): Promise<
  GenerationForecastModel[]
> => {
  const { data } = await getData("/forecast/availability/summary/3YW");
  return data;
};
